import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      {/* Navigation */}
      <nav className="navbar">
        <div className="logo">HYDROGLOW</div>
        <ul className="nav-links">
          <li><a href="#about">About</a></li>
          <li><a href="#services">Services</a></li>
          <li><a href="#why">Why Us</a></li>
          <li><a href="#faq">FAQ</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
        <a href="#contact" className="nav-cta">Get a Quote</a>
      </nav>

      {/* Hero Section with Background Video */}
      <section className="hero">
        <div className="hero-video-container">
          <video 
            className="hero-video" 
            autoPlay 
            muted 
            loop 
            playsInline
            poster="https://images.unsplash.com/photo-1607860108855-64acf2078ed9?w=1600&h=900&fit=crop"
          >
            <source 
              src="https://videos.pexels.com/video-files/3198628/3198628-uhd_2560_1440_25fps.mp4" 
              type="video/mp4" 
            />
          </video>
        </div>
        <div className="hero-overlay">
          <div className="hero-content">
            <span className="hero-tag">Premium Car Valeting</span>
            <h1>Clean Cars.<br />Clear Impressions.</h1>
            <p>Professional mobile valeting for private and commercial clients. Excellence at every wash.</p>
            <div className="hero-buttons">
              <a href="#contact" className="btn-primary">Get a Quote</a>
              <a href="#services" className="btn-secondary">Our Services</a>
            </div>
          </div>
        </div>
      </section>

      {/* About Section with Video */}
      <section id="about" className="about">
        <div className="container">
          <div className="about-grid">
            <div className="about-text">
              <span className="section-tag">About Us</span>
              <h2>Professional Valeting You Can Trust</h2>
              <p>
                HydroGlow is a professional mobile car valeting company committed to delivering
                exceptional vehicle care for both private and commercial clients. Built on years of
                hands-on experience in the automotive cleaning industry, we understand that a clean
                vehicle is more than appearance—it's a reflection of professionalism, pride, and
                attention to detail.
              </p>
              <p>
                Our team has extensive experience working with car dealerships, car wash centres,
                fleet operators, and private vehicle owners. Whether you have a single vehicle or
                an entire fleet, HydroGlow delivers outstanding results every time.
              </p>
              <div className="about-stats">
                <div>
                  <span className="stat-number">500+</span>
                  <span className="stat-label">Vehicles Valeted</span>
                </div>
                <div>
                  <span className="stat-number">98%</span>
                  <span className="stat-label">Satisfaction Rate</span>
                </div>
                <div>
                  <span className="stat-number">50+</span>
                  <span className="stat-label">Business Partners</span>
                </div>
              </div>
            </div>
            <div className="about-video-wrapper">
              <video 
                className="about-video" 
                autoPlay 
                muted 
                loop 
                playsInline
                poster="https://images.unsplash.com/photo-1607860108855-64acf2078ed9?w=800&h=600&fit=crop"
              >
                <source 
                  src="https://videos.pexels.com/video-files/3198628/3198628-uhd_2560_1440_25fps.mp4" 
                  type="video/mp4" 
                />
              </video>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section with Videos */}
      <section id="services" className="services">
        <div className="container">
          <span className="section-tag">Our Services</span>
          <h2>Comprehensive Valeting Solutions</h2>
          <div className="service-grid">
            <div className="service-card">
              <div className="service-video-wrapper">
                <img 
                  src="https://images.unsplash.com/photo-1520340356584-f9917d1eea6f?w=600&h=350&fit=crop" 
                  alt="Private vehicle valeting"
                  className="service-image"
                />
              </div>
              <div className="service-content">
                <h3>Private Vehicles</h3>
                <ul>
                  <li>Exterior Wash &amp; Dry</li>
                  <li>Interior Deep Clean</li>
                  <li>Full Valet Packages</li>
                  <li>Paint Protection</li>
                  <li>Upholstery Cleaning</li>
                  <li>Wheel &amp; Tyre Detailing</li>
                </ul>
              </div>
            </div>
            <div className="service-card featured">
              <div className="service-video-wrapper">
                <img 
                  src="https://images.unsplash.com/photo-1554744512-d6c603f27c54?w=600&h=350&fit=crop" 
                  alt="Commercial fleet valeting"
                  className="service-image"
                />
              </div>
              <div className="service-content">
                <h3>Commercial &amp; Fleet</h3>
                <ul>
                  <li>Dealership Valeting</li>
                  <li>Fleet Vehicle Cleaning</li>
                  <li>Executive Vehicle Prep</li>
                  <li>Company Vehicle Maintenance</li>
                  <li>Collection &amp; Delivery Prep</li>
                  <li>Bespoke Fleet Packages</li>
                </ul>
              </div>
            </div>
            <div className="service-card">
              <div className="service-video-wrapper">
                <img 
                  src="https://images.unsplash.com/photo-1583121274602-3e2820c69888?w=600&h=350&fit=crop" 
                  alt="Specialist car detailing services"
                  className="service-image"
                />
              </div>
              <div className="service-content">
                <h3>Specialist Services</h3>
                <ul>
                  <li>Ceramic Coating</li>
                  <li>Paint Correction</li>
                  <li>Headlight Restoration</li>
                  <li>Odour Elimination</li>
                  <li>Engine Bay Cleaning</li>
                  <li>Pre-Sale Preparation</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section id="why" className="why">
        <div className="container">
          <span className="section-tag">Why HydroGlow</span>
          <h2>Choose Excellence. Choose Reliability.</h2>
          <div className="why-grid">
            <div className="why-item">
              <div className="why-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
              </div>
              <h4>Professional Standards</h4>
              <p>Every vehicle is cleaned using proven techniques and premium products.</p>
            </div>
            <div className="why-item">
              <div className="why-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </div>
              <h4>Experienced Team</h4>
              <p>Our team brings years of experience across dealerships, fleets, and private clients.</p>
            </div>
            <div className="why-item">
              <div className="why-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 6v6l4 2" />
                </svg>
              </div>
              <h4>Competitive Pricing</h4>
              <p>Premium quality doesn't have to come with a premium price tag.</p>
            </div>
            <div className="why-item">
              <div className="why-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12 6 12 12 16 14" />
                </svg>
              </div>
              <h4>Reliable &amp; Consistent</h4>
              <p>We arrive on time and consistently deliver outstanding results.</p>
            </div>
            <div className="why-item">
              <div className="why-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  <polyline points="9 12 11 14 15 10" />
                </svg>
              </div>
              <h4>Customer First</h4>
              <p>Our reputation is built on repeat business and long-term relationships.</p>
            </div>
            <div className="why-item">
              <div className="why-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
                  <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
                </svg>
              </div>
              <h4>Flexible Service</h4>
              <p>Tailored solutions for dealerships, fleets, and private customers alike.</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="faq">
        <div className="container">
          <span className="section-tag">FAQ</span>
          <h2>Frequently Asked Questions</h2>
          <div className="faq-grid">
            <div className="faq-item">
              <h4>Are all your valeters trained and certified?</h4>
              <p>Yes, every member of our team is fully trained and certified to deliver professional valeting services.</p>
            </div>
            <div className="faq-item">
              <h4>Can we use your services as and when we need?</h4>
              <p>Absolutely. We offer flexible one-off or regular services to suit your schedule.</p>
            </div>
            <div className="faq-item">
              <h4>Do you clean company cars?</h4>
              <p>Yes, we provide regular cleaning for company vehicles, fleets, and commercial fleets.</p>
            </div>
            <div className="faq-item">
              <h4>Do you cover my area?</h4>
              <p>We primarily serve London and the surrounding areas. Contact us to check availability.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="contact">
        <div className="container">
          <div className="contact-grid-single">
            <div className="contact-info-full">
              <span className="section-tag">Get in Touch</span>
              <h2>Let's Discuss Your Valeting Needs</h2>
              <p>Whether you need a single vehicle valeted or a full fleet maintained, we're here to help.</p>
              <div className="contact-details-full">
                <div>
                  <strong>Phone</strong>
                  <p>07348 949046</p>
                </div>
                <div>
                  <strong>Email</strong>
                  <p>hydroglow@gmail.com</p>
                </div>
                <div>
                  <strong>Address</strong>
                  <p>Unit 1, 248 London Road<br />Romford, RM7 9EL</p>
                </div>
                <div>
                  <strong>Company No.</strong>
                  <p>08821165</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-grid">
            <div>
              <h4>HYDROGLOW</h4>
              <p>Professional car valeting with excellence at every wash.</p>
            </div>
            <div>
              <h4>Quick Links</h4>
              <ul>
                <li><a href="#about">About</a></li>
                <li><a href="#services">Services</a></li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </div>
            <div>
              <h4>Contact</h4>
              <p>07348 949046</p>
              <p>hydroglow@gmail.com</p>
              <p>Unit 1, 248 London Road<br />Romford, RM7 9EL</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2026 HydroGlow Car Wash &amp; Valeting. All rights reserved.</p>
            <p>Company No: 08821165</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;